import { GoogleAnalyticsConnection } from 'Types/GoogleAnalytics'
import { nanoid } from 'nanoid'

export const removePrefix = (value: string) => value.replace(/G-/gi, '')

export interface GoogleAnalyticsConnectionWithStateId extends GoogleAnalyticsConnection {
  stateId?: string
}

export const createDefaultConnection = (): GoogleAnalyticsConnectionWithStateId => ({
  tagId: undefined,
  trackingId: '',
  stateId: nanoid(),
})

export const findDomainNameByTagId = (
  tagId: number,
  domains: { value: string; label: string }[]
) => {
  const stringValue = tagId.toString()
  const domain = domains.find((domain) => domain.value === stringValue)
  return domain ? domain.label : ''
}
